
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "40px",
    "height": "40px",
    "viewBox": "0 0 40 40",
    "enable-background": "new 0 0 40 40",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "path",
                  "attrsMap": {
                    "fill": "#51565D",
                    "d": "M40,31.488C40,36.17,36.17,40,31.489,40H8.511C3.83,40,0,36.17,0,31.488V8.512C0,3.83,3.83,0,8.511,0\r\n\t\t\t\th22.978C36.17,0,40,3.83,40,8.512V31.488z"
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#BBBBBB",
        "d": "M13.006,34.734c-1.283,0-2.518-0.396-3.569-1.143c-1.339-0.955-2.229-2.375-2.503-3.998\r\n\tc-0.273-1.625,0.1-3.258,1.055-4.6l1.946-2.736h4.589l-3.488,4.902c-0.377,0.529-0.523,1.172-0.416,1.811\r\n\tc0.106,0.641,0.457,1.199,0.986,1.574c0.413,0.295,0.898,0.449,1.404,0.449c0.787,0,1.525-0.381,1.98-1.02l6.877-9.66l2.291,3.223\r\n\tl-6.121,8.605c-1.154,1.621-3.037,2.592-5.029,2.592H13.006z"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#BBBBBB",
        "d": "M14.99,10.025c-0.455-0.641-1.193-1.021-1.979-1.021c-0.506,0-0.993,0.154-1.406,0.449\r\n\tc-0.529,0.377-0.88,0.936-0.986,1.574c-0.107,0.641,0.039,1.283,0.416,1.811l3.488,4.904H9.935l-1.946-2.738\r\n\tc-0.955-1.34-1.328-2.975-1.055-4.598s1.164-3.043,2.503-3.998c1.052-0.748,2.286-1.143,3.571-1.143\r\n\tc1.992,0,3.875,0.969,5.029,2.592l6.121,8.605l-2.291,3.223L14.99,10.025z"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#BBBBBB",
        "d": "M32.217,23.746l-1.441-2.025h-3.27l2.539,3.57c0.293,0.41,0.408,0.912,0.324,1.41s-0.357,0.932-0.769,1.227\r\n\tc-0.321,0.229-0.7,0.35-1.095,0.35c-0.612,0-1.188-0.299-1.543-0.795l-2.441-3.434l-1.635,2.299l1.906,2.68\r\n\tc0.851,1.199,2.242,1.914,3.715,1.914c0.949,0,1.861-0.289,2.639-0.844c0.99-0.705,1.648-1.754,1.852-2.953\r\n\tC33.199,25.943,32.922,24.736,32.217,23.746z"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#BBBBBB",
        "d": "M31.146,9.9c-0.777-0.553-1.689-0.844-2.639-0.844c-1.473,0-2.864,0.717-3.715,1.916l-1.906,2.678\r\n\tl1.635,2.301l2.441-3.434c0.355-0.498,0.931-0.795,1.543-0.795c0.395,0,0.773,0.121,1.095,0.35c0.851,0.605,1.05,1.787,0.444,2.637\r\n\tl-2.539,3.568h3.271l1.439-2.023C33.674,14.207,33.193,11.357,31.146,9.9z"
      }
    }
  ]
})
    }
  